import React from 'react';
import {Link} from 'react-router-dom';

import Navigation from './Nav';
import Footer from './Footer';
import Header from './Header';
import './App.css';


import GoogleFontLoader from 'react-google-font-loader';
import {FaWhmcs,FaMobileAlt, FaPenFancy, FaDraftingCompass, FaGamepad,
        FaMusic, FaMapMarkerAlt, FaCreativeCommonsShare, FaDelicious, FaBarcode,
        FaAtom, FaSave, FaDatabase, FaEmpire, FaReact, FaArrowCircleUp
} from 'react-icons/fa';
import { Row, Col, Container,  Card, CardImg, CardText, CardBody,
         CardTitle, Button 
} from 'reactstrap';

function Productions() {

    return(
       <div id="pageUp" style={{backgroundColor:'#f5f5f5'}}>
            <Header />
            <Navigation/>

{/* GOOGLE FONTS -------------------------------------------------------------*/}       
<GoogleFontLoader
            fonts={[
              {
                font: 'Roboto',
                weights: [400, '400i'],
              },
              {
                font: 'Roboto Condensed',
                weights: [400, 700],
              },
              {
                  font: 'Titillium Web',
                  weights: [400, 700],
                },
                {
                  font: 'Poppins',
                  weights: [400, 700],
                },
            ]}
            subsets={['cyrillic-ext', 'greek']}
             />

{/* Header ------------------------------------------------------         */}
        <Row>
        
            <Col className='text-center' style={{ 
                animationName:'example', 
                animationDuration:'20s',
                backgroundColor:'#34b6bc', 
                height:'200px',
                borderBottomRightRadius:'90%',
                borderBottomLeftRadius:'50%'
                }}>
            <h2 style={{marginTop:'50px', color:'black'}}>Mes réalisations</h2>
            <Link to="/" style={{fontSize:'12px', color:'white', 
                                fontWeight:'bold',
                                marginRight:'10px'
                                }}>
             ACCUEIL</Link>
            - DÉVELOPPEMENT MOBILE ET WEB
            </Col>
        </Row>

{/* INTRODUCTION ------------------------------------------------------- */}
<Container>
    <Col className='text-center' style={{marginTop:'30px', fontFamily:'Poppins', color:'#767676'}}>
        Les projets présentés ont été développés lors de mes formations. 
        Ils ont été développés pour certains en équipe et pour d'autres 
        par moi-même.
        <h1 style={{fontSize:'25px', marginTop:'40px'}}>Développement mobile iOS</h1>
    </Col>
   
    {/* Liens vers projets MOBILES ------------------------------------ */}
    <Col className='text-center' style={{marginBottom:'20px'}}>
    <a href="#voyage" name="voyage" style={{color:'black', fontWeight:'bold'}}>Voyage</a>
    <a href="#maison" name="maison" style={{marginLeft:'20px', color:'black', fontWeight:'bold'}}>Maison</a>
    <a href="#outil" name="outil" style={{marginLeft:'20px', color:'black', fontWeight:'bold'}}>Outil</a>
    <a href="#photos" name="photos" style={{marginLeft:'20px',color:'black', fontWeight:'bold'}}>Photos</a>
    </Col>

    {/* LIGNE --------------------------------------------------------------------*/}
    <div style={{height:'1px', width:'100%', marginBottom:'100px', backgroundColor:'#7a7a7a'}}>
    </div>
    

{/* BACKPACK --------------------------------------------------------- */}
    <div id="voyage">
    <Row>
        <Col md='12'>
          <Card style={{marginLeft:'50px', marginRight:'50px', borderWidth:'0px'}}>
            <Row className="no-gutters" >
              <Col md="9">
                <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/backpack.png"
                  alt="Card image cap"
                />
              </Col>
              <Col md="3" sm="12">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>BackPack</h1></CardTitle>
                  <CardText style={{fontFamily:'Poppins'}}>
                  BackPack permet d'obtenir le taux de change et la météo locale ainsi que des traductions.
                  Une tab bar est utilisée pour naviguer entre les pages.
                  </CardText>

                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaWhmcs 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>API</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMobileAlt 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>User default</p>
                      </Col>

                      <Col className='text-center'>
                      <FaPenFancy 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>tests</p>
                      </Col>
                  </Row>

                  <Row>
                      <Col className='text-center'>
                      <FaPenFancy 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>Responsive</p>
                      </Col>
                      <Col className='text-center'>
                      <FaPenFancy 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>TableView</p>
                      </Col>
                  </Row>

                </CardBody>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>

{/* TRINDER ---------------------------------------------------------- */}
<div id="maison" style={{marginLeft:'50px', 
                        marginRight:'50px'}}>
    <Row>
        <Col>
          <Card style={{borderWidth:'0px',
                        marginTop:'100px'}}>
            <Row className="no-gutters" >

            <Col md="4" className='text-center'>
                <CardImg style={{height:'95%', width:'65%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/trinder.png"
                  alt="Card image cap"
                />
              </Col>

            <Col md="8">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>TRinder</h1></CardTitle>

                  <CardText>
                    Trinder à pour but de sensibiliser de manière ludique, les utilisateurs à leur mode de trie des déchêts, 
                    grâce à jeu et à un aide mémoire (CollectionView).
                    Ce projet a été pensé en équipe et j'ai été chargé du développement.
                  </CardText>

                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaDraftingCompass 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>Maquette</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMobileAlt 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>Responsive</p>
                      </Col>

                      <Col className='text-center'>
                      <FaGamepad 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>animate</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMusic 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>AVFoundation</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMapMarkerAlt 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>Map kit</p>
                      </Col>
                  
                  </Row>

                </CardBody>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>

{/* COUNT ON ME ---------------------------------------------------------- */}
<div id="outil" style={{marginLeft:'50px', 
                        marginRight:'50px'}}>
    <Row>
        <Col>
          <Card style={{borderWidth:'0px',
                        marginTop:'100px'}}>
            <Row className="no-gutters" >

            <Col md="4" className='text-center'>
                <CardImg style={{height:'95%', width:'65%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/countOnMe.png"
                  alt="Card image cap"
                />
              </Col>
                
            <Col md="8">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>Count On Me</h1></CardTitle>
                  <CardText>
                    countOnMe est une refonte de projet. Il a fallu réorganiser le code 
                    avec le modèle MVC, refaire l'interface en responsive et implémenter de nouvelles 
                    fonctionnalités.
                  </CardText>

                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaCreativeCommonsShare 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>Refonte de projet</p>
                      </Col>

                      <Col className='text-center'>
                      <FaDelicious 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>MVC</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMobileAlt 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>Responsive</p>
                      </Col>

                      <Col className='text-center'>
                      <FaPenFancy 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>test</p>
                      </Col>
                  
                  </Row>
                  
              
                </CardBody>
              </Col>

            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>


{/* Instagrid ---------------------------------------------------------- */}
<div id="photos">
    <Row>
        <Col>
          <Card style={{marginTop:'100px', marginLeft:'50px', marginRight:'50px', 
                        borderWidth:'0px',
                        }}>
            <Row className="no-gutters" >

            <Col md="4" className='text-center'>
                <CardImg style={{height:'95%', width:'65%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/instagrid.png"
                  alt="Card image cap"
                />
              </Col>

            <Col md="8">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>Instagrid</h1></CardTitle>
                  <CardText>
                    Instagrid est une application de montage photo. Elle permet aux utilisateurs de 
                    combiner des photos en choisissant parmi plusieurs dispositions. Le résultat 
                    final est au format carré et partageable avec ses amis. 
                    Les photos sont organisées selon une disposition que l’utilisateur peut choisir. 
                    Trois dispositions sont disponibles.
                  </CardText>
                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaDraftingCompass 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>tapGesture</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMobileAlt 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>imagePickerController</p>
                      </Col>

                      <Col className='text-center'>
                      <FaGamepad 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>alertController</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMusic 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>activityViewController</p>
                      </Col>

                      <Col className='text-center'>
                      <FaMapMarkerAlt 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'11px', fontFamily:'Poppins'}}>swipeGesture</p>
                      </Col>
                  
                  </Row>

                </CardBody>
              </Col>
             
            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>


{/* Application ReactNative --------------------------------------------------------- */}

    <Col className='text-center' style={{marginTop:'30px', color:'#767676'}}>  
        <h1 style={{fontSize:'25px', marginTop:'100px'}}>Développement mobile React Native</h1>
    </Col>
   
    {/* LIGNE --------------------------------------------------------------------*/}
    <div style={{height:'1px', width:'100%', marginBottom:'50px', backgroundColor:'#7a7a7a'}}>
         </div>
{/* ORDR --------------------------------------------------------- */}
<div id="restauration">
    <Row>
        <Col md='12'>
          <Card style={{marginLeft:'50px', marginRight:'50px', borderWidth:'0px'}}>
            <Row className="no-gutters" >
      
            <Col md="9">
              
                  <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/ordr.png"
                  alt="Card image cap"
                  />               
            </Col>

              <Col md="3" sm="12">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>OrdR</h1></CardTitle>
                  <CardText style={{fontFamily:'Poppins'}}>
                  OrdR est une application de prise de commande dans des restaurants.
                   Elle a été pensée et développée en équipe.
        
                  </CardText>

                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaSave 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>Token</p>
                      </Col>

                      <Col className='text-center'>
                      <FaAtom 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>Redux</p>
                      </Col>

                      <Col className='text-center'>
                      <FaBarcode 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>bar code</p>
                      </Col>
                  </Row>

                </CardBody>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>

{/* DEVELOPPEMENT WEB  ------------------------------------------------------------- */}
    <Col className='text-center' style={{marginTop:'30px', fontFamily:'Poppins', color:'#767676'}}>
        <h1 style={{fontSize:'25px', marginTop:'100px'}}>Développement Web </h1>
    </Col>
   
    {/* Liens vers projets MOBILES ------------------------------------ */}
    <Col className='text-center' style={{marginBottom:'20px'}}>
    <a href="#météo" name="météo" style={{color:'black', fontWeight:'bold'}}>Météo</a>
    <a href="#cinéma" name="cinéma" style={{marginLeft:'20px', color:'black', fontWeight:'bold'}}>Cinéma</a>
    <a href="#news" name="news" style={{marginLeft:'20px', color:'black', fontWeight:'bold'}}>News</a>
    </Col>

    {/* LIGNE --------------------------------------------------------------------*/}
    <div style={{height:'1px', width:'100%', marginBottom:'100px', backgroundColor:'#7a7a7a'}}>
    </div>

{/* WEATHER --------------------------------------------------------------------- */}
    <div id="météo">
    <Row>
        <Col md='12'>
          <Card style={{marginLeft:'50px', marginRight:'50px', borderWidth:'0px'}}>
            <Row className="no-gutters" >
              <Col md="9">
                <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/weather.png"
                  alt="Card image cap"
                />
              </Col>
              <Col md="3" sm="12">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>Weather App</h1></CardTitle>
                  <CardText style={{fontFamily:'Poppins'}}>
                  Weather App est réalisée avec ExpressJS et utilise MongoDB pour la base de donnée.
                  Grâce à l'utilisation d'API, cette application donne aux utilisateurs le temps qu'il fait 
                  dans des villes séléctionnées.
                  </CardText>

                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaWhmcs 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>API</p>
                      </Col>

                      <Col className='text-center'>
                      <FaEmpire 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>ExpressJS</p>
                      </Col>

                      <Col className='text-center'>
                      <FaDatabase 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>MongoDB</p>
                      </Col>
                  </Row>
  
                </CardBody>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>

{/* My MOVIES ---------------------------------------------------------------------  */}

    <div id="cinéma">
    <Row>

        <Col md='12'>
          <Card style={{marginTop:'100px', marginLeft:'50px', marginRight:'50px',
                        borderWidth:'0px'}}>
            
            <Row className="no-gutters" >

            <Col md="9">
                <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/myMovies.png"
                  alt="Card image cap"
                />
              </Col>

              <Col md="3" sm="12">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>My Movies</h1></CardTitle>
                  <CardText style={{fontFamily:'Poppins'}}>
                  My movies permet de voir les films à la une et les enregistrer dans ses favoris.
                  Ce site est développé en React (front-end) et ExpressJS (back-end).
                  </CardText>

                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaWhmcs 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>API</p>
                      </Col>

                      <Col className='text-center'>
                      <FaReact 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>React</p>
                      </Col>

                      <Col className='text-center'>
                      <FaDatabase 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>MongoDB</p>
                      </Col>
                  </Row>
  
                </CardBody>
              </Col>
             
            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>

{/* MORNING NEWS --------------------------------------------------------------------- */}
<div id="news">
    <Row>
        <Col md='12'>
          <Card style={{marginTop:'100px', marginLeft:'50px', marginRight:'50px' , marginBottom:'100px',
                        borderWidth:'0px'}}>
            <Row className="no-gutters" >
              <Col md="9">
                <CardImg style={{height:'100%', boxShadow:'20px 20px 20px #aaa'}}
                  top
                  src="/images/productions/morningNews.png"
                  alt="Card image cap"
                />
              </Col>
              <Col md="3" sm="12">
                <CardBody>
                  <CardTitle><h1 style={{fontSize:"20px"}}>Morning News</h1></CardTitle>
                  <CardText style={{fontFamily:'Poppins'}}>
                  Morning News est un site qui présente les dernières actualités.
                  Il est réalisé avec ExpressJS et utilise MongoDB pour la base de donnée.
                  </CardText>

                  <Row style={{marginTop:'10px'}}>
                      <Col className='text-center'>
                      <FaWhmcs 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>API</p>
                      </Col>

                      <Col className='text-center'>
                      <FaEmpire 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>ExpressJS</p>
                      </Col>

                      <Col className='text-center'>
                      <FaDatabase 
                        size={35} color={'white'} 
                        style={{backgroundColor:'grey',
                        borderRadius:'50%'
                        }}/>
                        <p style={{fontSize:'10px', fontFamily:'Poppins'}}>MongoDB</p>
                      </Col>
                  </Row>
  
                </CardBody>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>                        
    </div>


{/* LIEN GITHUB ---------------------------------------------------------------- */}
    <Col className='text-center'>
        <h1 style={{fontSize:'20px'}}>Retrouvez le code source des projets
        <a href="https://github.com/MadameZ?tab=repositories" name="github" style={{color:'black'}}> <u>ici</u>
            <Button style={{backgroundColor:'#f5f5f5', borderWidth:'0px', textDecoration:'underline'}}></Button>
        </a></h1>
    </Col>

{/* RETOUR HAUT DE PAGE  ------------------------------------------------------- */}
    <Col className='text-center' style={{marginTop:'50px'}}>
    <a href="#pageUp" name="pageUp">
        <Button style={{backgroundColor:'#f5f5f5', borderWidth:'0px'}}>
        <FaArrowCircleUp 
            size={35} color={'#34b6bc'} 
            style={{backgroundColor:'white',
            borderRadius:'50%'
        }}/>
        </Button>
    </a>
    </Col>
    

    <Col className='text-center'>
    <p style={{marginTop:'20px', marginBottom:'100px',
                fontFamily:'Poppins'}}>Retour en Haut de la page</p>
    </Col>




</Container>
    <Footer />   
    </div>
    )

}

export default Productions;